export enum KsefReceivedDocumentStatus {
    XmlDownloadingInProgress = 'XmlDownloadingInProgress',
    XmlDownloadingError = 'XmlDownloadingError',
    XmlDownloadingSuccess = 'XmlDownloadingSuccess',
    ProcessingSuccess = 'ProcessingSuccess',
    ProcessingError = 'ProcessingError',
}
